import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { deleteAllCookie, getLoggedInUser } from '../../shared/security/cookies';
import { LoggedInUser } from '../../shared/types/user';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
  const token = LOGGED_IN_USER.token;

  // Check if token is present
  if (!token) {
    const currentUrl = router.url;

    if (currentUrl.includes('/sign-in') || currentUrl.includes('/sign-up')) {
      return next(req);
    } else {
      localStorage.clear();
      deleteAllCookie();
      router.navigate(['/sign-in']);
      return throwError(() => new Error('No authentication token found'));
    }
  }

  // Decode and validate token expiration
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    console.log('JWT Decoded Payload', payload.exp);
    console.log('Current Time', currentTime);

    if (payload.exp && payload.exp < currentTime) {
      localStorage.clear();
      deleteAllCookie();
      return throwError(() => new Error('Authentication token has expired'));
    }
  } catch (error) {
    // Invalid token format
    localStorage.clear();
    deleteAllCookie();
    return throwError(() => new Error('Invalid authentication token'));
  }

  // Pass through the original request without modification
  return next(req);
};
